import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import OrderRemainingHoursReportList, { DispatchProps, OwnProps, StateProps } from './OrderRemainingHoursReportList';
import { StoreState } from 'src/store/reducers';
import { QueryParams } from 'src/types/grid';
import {
    getOrderRemainingHoursReports,
    getOrderRemainingHoursReportsCsv,
    getOrderRemainingHoursReportsTotal,
} from 'src/store/actions/orderRemainingHoursReport-actions';
import { selectNameStudents } from 'src/store/selectors/students-selectors';
import { selectNameVendors } from 'src/store/selectors/vendors-selectors';
import { selectNameDistricts } from 'src/store/selectors/districts-selectors';
import { getStudentsSmall } from 'src/store/actions/student-actions';
import { getVendorsSmall } from 'src/store/actions/vendor-actions';
import { getDistrictsSmall } from 'src/store/actions/district-actions';
import { clearTotal } from '../../../../../store/actions/providerReport-actions';
import { selectNameSerTypesDropDown } from '../../../../../store/selectors/service-types-selectors';
import { getServiceTypes } from '../../../../../store/actions/service-type-actions';

function mapStateToProps(state: StoreState, ownProps: OwnProps): StateProps {
    return {
        data: state.orderRemainingHoursReports.data,
        students: selectNameStudents(state),
        districts: selectNameDistricts(state),
        totals: state.orderRemainingHoursReports.totals,
        vendors: selectNameVendors(state),
        serviceTypes: selectNameSerTypesDropDown(state),
        inProgress: state.orderRemainingHoursReports.inProgress,
    };
}

function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps): DispatchProps {
    return {
        getData: (params: QueryParams) => dispatch(getOrderRemainingHoursReports(params)),
        getDataCsv: (params: QueryParams) => dispatch(getOrderRemainingHoursReportsCsv(params)),
        getDataTotal: (params: QueryParams) => dispatch(getOrderRemainingHoursReportsTotal(params)),
        getStudents: (params: QueryParams) => dispatch(getStudentsSmall(params)),
        getVendors: (params: QueryParams) => dispatch(getVendorsSmall(params)),
        getDistricts: (params: QueryParams) => dispatch(getDistrictsSmall(params)),
        getServiceTypes: (params: QueryParams) => dispatch(getServiceTypes(params)),
        clearTotal: () => dispatch(clearTotal()),
    };
}

const OrderRemainingHoursReportListScreen = connect<StateProps, DispatchProps, OwnProps, StoreState>(
    mapStateToProps,
    mapDispatchToProps,
)(OrderRemainingHoursReportList);

export default OrderRemainingHoursReportListScreen;
